import React, { useState, useContext } from "react"
import { UserContext } from "../../../context/userContext"
import trcss from "../../../styles/Telerecovery.module.css"
import gMessages from "../../../styles/GlobalMessages.module.css"
import { Dropdown } from "primereact/dropdown"
import { Button } from "primereact/button"
import {
  trApiSendChatMessageToParticipant,
  trApiGetChatConversationSid,
} from "../telerecoveryApi"
import { LoaderMedium } from "../../../components/Loaders"
import { InputTextarea } from "primereact/inputtextarea"
import { getActualUTCTime } from "../Utils"

export default function ParticipantNewChat({ participants, onMessageSent }) {
  const userCtx = useContext(UserContext)
  const { user } = userCtx.session
  const [newChatText, setNewChatText] = useState("")
  const [selectedParticipant, setSelectedParticipant] = useState(null)
  const [sendingMessage, setSendingMessage] = useState(false)

  const sendMessage = () => {
    if (!selectedParticipant || newChatText === "" || sendingMessage) {
      return
    }

    setSendingMessage(true)

    trApiGetChatConversationSid(
      userCtx.tokens.getTelerecoveryToken(),
      user.staff_id,
      selectedParticipant.participant_id,
      user.organization_id,
    )
      .then(
        (response) => {
          const convSid = response
          if (convSid) {
            let data = {
              body: newChatText,
              fromId: user.staff_id,
              convSid: convSid,
            }
            trApiSendChatMessageToParticipant(
              userCtx.tokens.getTelerecoveryToken(),
              data,
            )
              .then(
                (response) => {
                  onMessageSent({
                    sid: convSid,
                    caseId: selectedParticipant.participant_id,
                    caseName: selectedParticipant.name,
                    caseInitials: selectedParticipant.initials,
                    lastMessageAt: getActualUTCTime(),
                    containsUnread: false,
                  })
                },
                (err) => console.log(err),
              )
              .catch((error) => {
                console.log(error)
              })
              .finally(() => {
                setSendingMessage(false)
              })
          }
        },
        (err) => console.log(err),
      )
      .catch((error) => {
        console.log(error)
      })
  }

  if (sendingMessage) {
    return <LoaderMedium />
  }

  return (
    <div className={trcss.chatWrapper}>
      <div className={gMessages.newChatForm}>
        <h2>New message to participant</h2>
        <hr />
        <div className={gMessages.content}>
          <div className={gMessages.field} style={{ width: "100%" }}>
            <label className={gMessages.label}>Select Participant</label>
            <Dropdown
              value={selectedParticipant}
              options={participants}
              onChange={(e) => setSelectedParticipant(e.value)}
              showClear
              optionLabel="name"
              filter
              filterBy="name"
              className={gMessages.selector}
              placeholder="Select a Participant"
            />
          </div>
          <div className={trcss.chatWindowFooter}>
            <InputTextarea
              placeholder="Type your message"
              autoResize
              className={trcss.newMessageBox}
              value={newChatText}
              onChange={(e) => setNewChatText(e.target.value)}
              rows={1}
              disabled={!selectedParticipant || sendingMessage}
            />
            <div style={{ display: "flex", alignItems: "end" }}>
              <Button className={trcss.sendBtn} onClick={() => sendMessage()} />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
